module.exports = __webpack_public_path__ + "Teams.06cb518cddfba47bd65bb10aca6e4286.hashedasset.svg";